<template>
    <div class="row pds-header-box">
        <div class="col-12 col-lg-8">
            <gallery-box
                :entry="entry"
                :is-loading="isLoading"
            ></gallery-box>
        </div>
        <div class="col-12 col-lg-4">
            <buy-box
                :entry="entry"
                :is-loading="isLoading"
                :is-active="isActive"
            ></buy-box>
        </div>
    </div>
</template>

<script>
import GalleryBox from "../molecules/GalleryBox.vue";
import BuyBox from "../molecules/BuyBox.vue";

export default {
    name: 'ProductHeaderBox',
    props: {
        entry: null,
        isLoading: true,
        isActive: false,
    },
    components: {
        BuyBox,
        GalleryBox,
    }
}
</script>
